export const environment = {
  production: false,
  API_URL: "https://tiferet-gt-1.onrender.com/api",

  // 'https://tiferet-gt-1.onrender.com/api',
  // http://localhost:5000/api
};
